<h2 mat-dialog-title>
  <mat-icon color="">bookmark</mat-icon>
  Estado de Servicios de Mantenimiento
</h2>

<mat-dialog-content class="mat-typography">
  <form [formGroup]="formGroup">

    <!-- Lista de servicios de mantenimiento -->
    <div class="maintenance-services-section">
      <!-- Resumen de servicios -->
      @if (getMaintenanceFilesWithContracts().length > 0) {
        <div class="services-summary">
          <mat-divider></mat-divider>
          <div class="summary-content">
            <h3>Resumen</h3>
            <div class="summary-stats">
              <div class="stat-item completed">
                <mat-icon>check_circle</mat-icon>
                <span>Realizados: {{ getCompletedServicesCount() }}</span>
              </div>
              <div class="stat-item pending">
                <mat-icon>schedule</mat-icon>
                <span>Pendientes: {{ getPendingServicesCount() }}</span>
              </div>
              <div class="stat-item total">
                <mat-icon>assignment</mat-icon>
                <span>Total: {{ getMaintenanceFilesWithContracts().length }}</span>
              </div>
            </div>
          </div>
        </div>
      }
      <br>

        @if (getMaintenanceFilesWithContracts().length > 0) {
          <div class="services-container">
            @for (serviceItem of getMaintenanceFilesWithContracts(); track trackByMaintenanceFile($index, serviceItem)) {
              <div
                class="service-item">
                <!-- Información del servicio -->
                <div class="service-info">
                  <div class="service-header">
                    <div class="date-info">
                      <mat-icon color="">event</mat-icon>
                      <span class="service-date">{{ serviceItem.date | date:'dd/MM/yyyy' }}</span>
                    </div>
                    <div class="contract-info">
                      <mat-icon color="">description</mat-icon>
                      <span class="contract-name">{{ serviceItem.contractName }}</span>
                    </div>
                    <!-- Nueva sección para el tipo de mantenimiento -->
                    <div class="maintenance-type-info">
                      <mat-icon color="">{{ getMaintenanceTypeIcon(serviceItem.type) }}</mat-icon>
                      <span class="maintenance-type" [ngClass]="getMaintenanceTypeClass(serviceItem.type)">
                        {{ getMaintenanceTypeText(serviceItem.type) }}
                      </span>
                    </div>
                  </div>
                  <!-- Estado y controles -->
                  <div class="service-controls">
                    <div class="status-section">
                      <span class="status-label">Estado:</span>
                      <div class="status-chip" [ngClass]="getStatusClass(serviceItem.status)">
                        <mat-icon>{{ serviceItem.status ? 'check_circle' : 'pending' }}</mat-icon>
                        {{ getStatusText(serviceItem.status) }}
                      </div>
                    </div>
                    <!-- Toggle de estado -->
                    <div class="status-toggle">
                      <mat-slide-toggle
                        [checked]="serviceItem.status"
                        (change)="toggleServiceStatus(serviceItem)"
                        color="primary">
                        {{ serviceItem.status ? 'Completado' : 'Marcar como realizado' }}
                      </mat-slide-toggle>
                    </div>
                  </div>
                  <!-- Campo de número de folio -->
                  @if (serviceItem.status) {
                    <div class="folio-section">
                      <mat-form-field appearance="outline" class="folio-field">
                        <mat-label>Número de folio</mat-label>
                        <input matInput
                          [value]="serviceItem.fileNumber"
                          (input)="updateFileNumber(serviceItem, $event)"
                          placeholder="Ej: FOL-001-2024"
                          required>
                        <mat-icon matSuffix color="">receipt</mat-icon>
                        <mat-hint>Ingrese el número de folio del servicio realizado</mat-hint>
                      </mat-form-field>
                    </div>
                  }
                  @if (serviceItem.status) {
                    <button mat-raised-button
                      (click)="openUpload(serviceItem,'upload')"
                      matTooltip="Cargar documento de mantenimiento"
                      [disabled]="!serviceItem.fileNumber || serviceItem.fileNumber.length === 0">
                      <mat-icon>attach_file</mat-icon>
                    </button>
                  }
                  @if (serviceItem.status) {
                    <button mat-raised-button
                      (click) = "openDownload(serviceItem,'download')"
                      matTooltip = "Ver documento de mantenimiento"
                      [disabled] = "!serviceItem.pdf">
                      <mat-icon>visibility</mat-icon>
                    </button>
                  }
                </div>
                <!-- Indicador visual de estado -->
                <div class="status-indicator" [ngClass]="getStatusClass(serviceItem.status)">
                  <mat-icon>{{ serviceItem.status ? 'check_circle' : 'schedule' }}</mat-icon>
                </div>
              </div>
            }
          </div>
        }

        <!-- Mensaje cuando no hay servicios programados -->
        @if (getMaintenanceFilesWithContracts().length === 0) {
          <div class="no-services-message">
            <mat-icon color="">info</mat-icon>
            <span>No hay servicios de mantenimiento programados</span>
          </div>
        }
      </div>

    </form>

  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close color="warn">Cancelar</button>
    <button mat-raised-button color="primary" (click)="update()">Guardar</button>
  </mat-dialog-actions>